import { useState } from 'react'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

export const useUploadDocuments = () => {
  const { showAlert } = useAlert()
  const [isUploading, setIsUploading] = useState(false)

  const uploadDocuments = async (estateId: string, files: File[]) => {
    setIsUploading(true)

    try {
      const newFiles = files.filter((file) => {
        return file instanceof File && file.lastModified !== 0
      })

      if (newFiles.length === 0) return true

      const formData = new FormData()
      formData.append('estateId', estateId)

      newFiles.forEach((file) => {
        formData.append('files', file)
      })

      const { data: response } =
        await getApi().uploadsAppApiControllerUploadMultipleFiles(
          formData as unknown as { estateId: string; files: File[] }
        )

      if ('success' in response) {
        showAlert('success', 'Nahratie súboru prebehlo úspešne.')
        return
      }
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    } finally {
      setIsUploading(false)
    }
  }

  return {
    isUploading,
    uploadDocuments,
  }
}
